import React from 'react'
import { Avvia_Partita } from '../../Components'
const Avvia_Partita3 = () => {
    return (
        <div>
            <Avvia_Partita no={2}/>
        </div>
    )
}

export default Avvia_Partita3
